import _clientService from "@/services/clients";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getCompanies = createAsyncThunk(
  "clients/getCompanies",
  async () => {
    const companies = await _clientService.getCompanies();
    return companies;
  },
);

export const getDataCompanies = createAsyncThunk(
  "clients/getDataCompanies",
  async () => {
    const companies = await _clientService.getDataCompanies();
    return companies;
  },
);

export const getFolders = createAsyncThunk(
  "clients/getFolders",
  async (clienteId: string) => {
    const folders = await _clientService.getFolders(clienteId);
    return folders;
  },
);

export const getFolderData = createAsyncThunk(
  "clients/getFolderData",
  async (folderId: string) => {
    const folderData = await _clientService.getFolderData(folderId);
    return folderData;
  },
);

export const getCompaniesSearch = createAsyncThunk(
  "clients/getCompaniesSearch",
  async () => {
    const companiesSearch = await _clientService.getCompaniesSearch();
    return companiesSearch;
  },
);

export const getDataUpdates = createAsyncThunk(
  "clients/getDataUpdates",
  async () => {
    const dataUpdates = await _clientService.getDataUpdates();
    return dataUpdates;
  },
);

export const updateDb = createAsyncThunk("clients/updateDb", async () => {
  const result = await _clientService.updateDb();
  return result;
});
